<template>
  <div class="confirm-device__container">
    <div class="confirm-device__close-icon">
      <div @click.prevent="closeConfirmDeviceModal">
        <IconCross style="cursor: pointer" color="#f37053" size="25px" />
      </div>
    </div>
    <div class="confirm-device__body">
      <div class="confirm-device__device-title" style="font-weight: bold">
        {{ $t('product_form.confirm_device.are_you_sure_device') }}
      </div>
      <div class="confirm-device__description">
        {{ $t('product_form.confirm_device.description') }}
      </div>
      <div class="confirm-device__device">
        {{ $t('product_form.confirm_device.selected_device') }}
        <div class="confirm-device__name">
          {{ selectedDevice && selectedDevice.name }}
        </div>
      </div>
      <div class="confirm-device__description">
        {{ $t('product_form.confirm_device.tip') }}
      </div>
      <div class="confirm-device__actions">
        <button class="confirm-device__back" @click="returnToSelectDevice">
          {{ $t('product_form.confirm_device.negative_answer_device') }}
        </button>
        <button class="confirm-device__next" @click="confirmDeviceModal">
          {{ $t('product_form.confirm_device.positive_answer_device') }}
        </button>
      </div>
      <div
        v-if="isAndroid"
        class="confirm-device__discover-device"
        @click.prevent="showExplainPhoneType"
      >
        {{ $t('product_form.confirm_device.dont_know_my_device') }}
      </div>
    </div>
  </div>
</template>

<script>
import IconCross from '~/components/icons/cross/Cross.vue'
import pushDataLayer from '~/mixins/gtm/push-data-layer'

export default {
  components: {
    IconCross,
  },
  mixins: [pushDataLayer],
  props: {
    selectedDevice: {
      type: Object,
      default: () => {},
    },
    selectedBrand: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isAndroid() {
      return ['Samsung', 'Motorola', 'Xiaomi', 'Realme'].includes(
        this.selectedBrand?.name
      )
    },
  },
  methods: {
    showExplainPhoneType() {
      this.$emit('showExplainPhoneType')
      this.pushDataLayer({
        event: 'genericEvent',
        eventCategory: 'navigation',
        eventAction: 'showExplainPhoneType',
        eventValue: {
          device: this.selectedDevice?.name,
          brand: this.selectedBrand?.name,
        },
      })
    },
    confirmDeviceModal() {
      this.$emit('confirmDeviceModal')
      this.pushDataLayer({
        event: 'genericEvent',
        eventCategory: 'navigation',
        eventAction: 'confirmDeviceModal',
        eventValue: {
          device: this.selectedDevice?.name,
          brand: this.selectedBrand?.name,
        },
      })
    },
    returnToSelectDevice() {
      this.$emit('returnToSelectDevice')
      this.pushDataLayer({
        event: 'genericEvent',
        eventCategory: 'navigation',
        eventAction: 'returnToSelectDevice',
        eventValue: {
          device: this.selectedDevice?.name,
          brand: this.selectedBrand?.name,
        },
      })
    },
    closeConfirmDeviceModal() {
      this.$emit('closeConfirmDeviceModal')
    },
  },
}
</script>

<style lang="scss">
.confirm-device {
  &__close-icon {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
  }
  &__container {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fcfdf7;
    border-radius: 7px;
    padding: 20px;
    z-index: 104;
    width: 100%;
    max-width: 350px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  }
  &__body {
    font-size: 17px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__title {
    text-transform: uppercase;
    font-size: 13px;
    font-weight: 700;
    text-align: center;
  }
  &__subtitle {
    font-size: 15px;
    font-weight: 400;
    text-align: center;
  }
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f37053;
    color: #fff;
    padding: 10px 20px;
    border-top-left-radius: 7px;
    border-top-right-radius: 7px;
  }
  &__device {
    padding-top: 10px;
    display: block;
    text-align: center;
    font-size: 15px;
  }
  &__device-title {
    padding-top: 10px;
    display: block;
    text-align: center;
    font-size: 20px;
  }
  &__description {
    padding-top: 15px;
    text-align: center;
    color: #525252;
    font-size: 15px;
  }
  &__back,
  &__next,
  &__start {
    flex: 1;
    text-align: center;
    padding: 10px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    width: 80%;
  }
  &__next {
    background-color: transparent;
    border: 1px solid #f37053;
    font-weight: bold;
    color: #f37053;
  }
  &__back {
    background-color: #f37053;
    color: white;
    font-weight: bold;
  }
  &__name {
    font-weight: bold;
  }
  &__actions {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 10px;
  }
  &__discover-device {
    padding-top: 20px;
    font-size: 14px;
    color: #f37053;
    text-decoration: underline;
    text-align: center;
    cursor: pointer;
  }
}
@media (min-width: 768px) {
  .confirm-device {
    &__container {
      max-width: 420px;
    }
    &__title {
      font-size: 16px;
    }
    &__subtitle {
      font-size: 20px;
      margin: 14px 0px 25px 0px;
    }
    &__actions {
      flex-direction: row;
    }
  }
}
</style>
